import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import ReactHtmlParser from 'react-html-parser';

export class HTMLRenderer extends React.Component {
  render() {
    return ReactHtmlParser(this.props.data);
  }
}

export default connectDynamic(HTMLRenderer);
